const Price = {
  // pdf价格
  "--theme-pdf-price-tag-bg": "",
  "--theme-pdf-price-tag-bg-hover": "",
  "--theme-pdf-price-tag-color": "#111112",
  "--theme-pdf-price-tag-color-hover": "#FFFFFF",

  "--theme-pdf-price-li-color": "#4B4B4C",
  "--theme-pdf-price-li-color-hover": "#FFFFFF",

  "--theme-pdf-price-tips-color": "#7D7D7F",
  "--theme-pdf-price-tips-color-hover": "#FFFFFF",
  "--theme-pdf-price-tips-bg": "#fff",
  "--theme-pdf-price-tips-bg-hover": "rgba(0,0,0,0)",

  "--theme-pdf-price-color": "#26D7B9",
  "--theme-pdf-price-color-hover": "#FFFFFF",

  "--theme-pdf-price-inner-bg": "#fff",
  "--theme-pdf-price-inner-bg-hover": "linear-gradient(132deg, #0195C3 0%, #00CAA8 100%)",

  "--theme-pdf-price-btn": "linear-gradient(132deg, #0195C3 0%, #00CAA8 100%)",
  "--theme-pdf-price-btn-hover": "#FFE349",

  "--theme-pdf-price-btn-color": "#fff",
  "--theme-pdf-price-btn-color-hover": "#111112",
}

const Questions = {
  // PDF
  // PDF quetions
  "--theme-pdf-questions-title-color": "#111112",
  "--theme-pdf-quesions-bg": "#26D7B9",
  "--theme-pdf-quesions-inner-bg": "#FFFFFF",

  "--theme-pdf-quesions-item-bg": "#FFFFFF",
  "--theme-pdf-quesions-item-title-color": "#111112",
  "--theme-pdf-quesions-item-title-color-hover": "#26D7B9",

  "--theme-pdf-question-icon-filter": "",

  "--theme-pdf-quesions-item-des-color": "#7D7D7F",
}


const Steps = {
  "--theme-pdf-step-bg": "rgba(38, 215, 185, 0.1)",
  "--theme-pdf-step-subtitle-color": "#fff",
  "--theme-pdf-step-inner-bg": "linear-gradient(132deg, #0195C3 0%, #00CAA8 100%)"
}

const Explain = {
  "--theme-pdf-explain-inner-bg": "white",
}


const Comment = {
  "--theme-pdf-comment-item-bg": "#F2F4F3",
  "--theme-pdf-comment-city-color": "#7D7D7F",
  "--theme-pdf-comment-name-color": "#111112",
  "--theme-pdf-comment-subtitle-color": "#111112",

  "--theme-pdf-comment-item-bg-hover": "linear-gradient(132deg, #0195C3 0%, #00CAA8 100%)",
  "--theme-pdf-comment-city-color-hover": "#FFF",
  "--theme-pdf-comment-name-color-hover": "#FFF",
  "--theme-pdf-comment-subtitle-color-hover": "#FFF",
}

export const coustomPDFturquoiseTheme = {
  //主题背景颜色
  "--theme-primary": "#26D7B9",
  //默认黑
  "--theme-primary-black": "#252325",
  //默认白
  "--theme-primary-white": "#ffffff",
  // 页脚 logo 字体颜色
  "--theme-primary-footer-logo-suffix": "#26D7B9",
  // 登录按钮 字体颜色
  "--theme-primary-login-btn-suffix": "#111112",
  // 不透明度70%
  "--theme-primary-white-70": "#b2b2b2",
  //主题亮色
  "--theme-primary-suffix": "#26D7B9",
  //主题深副色
  "--theme-primary-dark-sub": "#E4430F",
  //主题浅副色
  "--theme-primary-light-sub": "#FF8761",
  //价格 tag
  "--theme-primary-price-tag": "#4C3626",
  "--theme-primary-price-tag-bg": "#FFCF52",
  //tiny 类
  "--theme-primary-tiny": "#666166",
  //footer 背景色
  "--theme-primary-footer-bg": "#000000",
  //输入框聚焦
  "--theme-focus": "#3377ff",
  //输入框错误
  "--theme-focus-err": "#ea3042",

  ...Price,
  ...Questions,
  ...Steps,
  ...Explain,
  ...Comment
}